import WCCVideo from 'models/attachments/video';
import { UploadToS3Config, UploadToS3Result } from "../../components/controls/uploaders/operations/uploadToS3";
import { WCCDialogConfig } from '../../components/dialog/dialog';
import overlayManager from '../overlay';

const { allowedUploadVideoExtensions } = settings;

components.preload('qualzy-s3-file-uploader');

export interface QualzyVideoPickerManagerConfig {
    key?: string
}
export default class QualzyVideoPickerManager {

    private _totalFilesUploading = 0;
    
    constructor(private config: QualzyVideoPickerManagerConfig) { }

    pick() {        
        return new Promise<WCCVideo | undefined>(resolve => {            
            overlayManager.toOverlay(`
<wcc-dialog params="model: dialog">
    <qualzy-s3-file-uploader params="model: s3FileUploaderConfig" />
</wcc-dialog>`, {
                lock: true,

                data: stage => ({
                    dialog: <WCCDialogConfig>{
                        headerText: '',
                        //headerColor: 'transparent',
                        hideFooter: true,
                        showCancelInHeader: true,
                        fitContent: true,
                        animate: true,
                        width: 620,
                        height: 'auto',
                        cancel: ['Close', async () => {
                            if (this._totalFilesUploading > 0) {
                                system.showErrorMessage(labels.PleaseWait);
                            }
                            else {
                                stage.close();
                            }
                        }]                        
                    },

                    s3FileUploaderConfig: new UploadToS3Config(
                        WCC.Settings.S3Bucket,                                          // bucket
                        WCC.Settings.S3Region,                                          // region
                        "userfiles/",                                                   // folder
                        `${WCC.Settings.WccApiUrl}/api/s3/start-single-part-upload`,    // singleFileStartUploadUrl
                        `${WCC.Settings.WccApiUrl}/api/s3/start-multi-part-upload`,     // multiPartFileStartUploadUrl
                        `${WCC.Settings.WccApiUrl}/api/s3/finish-multi-part-upload`,    // multiPartFileFinishUploadUrl
                        false,                                                          // allowMultipleFiles
                        null, //1024 * 1024 * 2                                         // allowedMaxSizeInBytes
                        allowedUploadVideoExtensions.map(ext => `.${ext}`),             // allowedFileExtensions
                        settings.loginToken(),                                          // authToken
                        {
                            //events
                            OnFileUploadStarting: () => {
                                this._totalFilesUploading++;
                            },
                            
                            OnFileUploaded: (result: UploadToS3Result) => {
                                resolve(this.createVideoFromResult(result));
                                // close dialog
                                stage.close();
                            },
                            
                            OnFileUploadComplete: () => {
                                this._totalFilesUploading--;
                            }
                        },
                        true,                                                           // allowVideoRecording
                        false,                                                          // allowAudioRecording
                        false,                                                          // allowScreenRecording
                        false,                                                          // allowScreenAndVideoRecording
                        true                                                            // allow picked files
                    )
                }),

                onClose: () => resolve(undefined)
            });
        });
    }

    createVideoFromResult(result: UploadToS3Result): WCCVideo { 
        // Note: (DB) - we don't need all the details like width/height/filename here as they get recreated as part of the pipeline processing
        return new WCCVideo({
            FileType: enums.AttachmentTypes.Video.value,
            Link: result.FileUrl,
            UserFileId: result.FileId,
            CDNFileName: this.config.key,
            CreateDate: new Date().toISOString(),
            Files: [    // we need the file as part of the video object so it gets wired up correctly when the thread saves
                {
                    UserFileId: result.FileId,
                    Link: result.FileUrl,
                    Type: enums.UserFileTypes.OriginalVideo.value,
                    CreateDate: new Date().toISOString()
                }
            ]
        });
    }
}